<div class="editpatient--body newrx--body edit--drug">
    <div class="editpatient">
        <div class="row content--heading">
            <div class="col-md-9">
                <app-drug-common-header [headingData]="'Drug Notes'"></app-drug-common-header>
            </div>
            <div class="text-end pull-right col-md-3 padding-0">
                <button class="hotkey_success" (click)="routeBackToPrevScreen()" id="durgNotesCancel"><span>C</span> Cancel</button>
            </div>
        </div>
    </div>
</div>
<app-notes-log [DrugInfo]="drugdata" [NotesInfoFor]="drugdata.Drug.Name"
(emitFocusOnCancel)="focusOnCancel($event)"></app-notes-log>
